import HeaderMain from "../components/header/HeaderMain";
import NavMain from "../components/nav/NavMain";
import ReportOutstandingBalance from "../reports/ReportOutstandingBalance";


function OutstandingBalanceReport() {
    return (
        <>
            <NavMain slug="outstanding-balance-report" parent="3" />
            <HeaderMain slug="outstanding-balance-report" />
            <div className="main-content">
                <ReportOutstandingBalance />
            </div>
        </>
    );
}

export default OutstandingBalanceReport;